import React from 'react';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from './ui/accordion';
import { faqs } from '../data/mock';
import { HelpCircle } from 'lucide-react';

const FAQSection = () => {
  return (
    <section id="faq" className="py-24 bg-gray-50 dark:bg-gray-800 relative overflow-hidden">
      {/* Background decorations */}
      <div className="absolute top-0 left-0 w-96 h-96 bg-primary-blue/5 rounded-full blur-3xl" />
      <div className="absolute bottom-0 right-0 w-96 h-96 bg-primary-cyan/5 rounded-full blur-3xl" />

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 relative">
        {/* Section Header */}
        <div className="text-center max-w-3xl mx-auto mb-16">
          <span className="inline-block px-4 py-2 bg-primary-cyan/10 text-primary-blue dark:text-primary-cyan font-semibold rounded-full text-sm mb-4">
            FAQ
          </span>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-gray-900 dark:text-white mb-6">
            Questions
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-primary-blue to-primary-cyan"> fréquentes</span>
          </h2>
          <p className="text-lg text-gray-600 dark:text-gray-300">
            Retrouvez les réponses aux questions les plus courantes de nos clients.
          </p>
        </div>

        {/* FAQ Accordion */}
        <div className="bg-white dark:bg-gray-900 rounded-3xl shadow-xl border border-gray-100 dark:border-gray-700 p-6 md:p-8">
          <Accordion type="single" collapsible className="space-y-4">
            {faqs.map((faq, index) => (
              <AccordionItem
                key={index}
                value={`item-${index}`}
                className="border border-gray-100 dark:border-gray-700 rounded-2xl px-6 data-[state=open]:bg-gray-50 dark:data-[state=open]:bg-gray-800 transition-colors duration-200"
              >
                <AccordionTrigger className="text-left text-lg font-semibold text-gray-900 dark:text-white hover:text-primary-blue dark:hover:text-primary-cyan py-5 [&[data-state=open]>svg]:text-primary-cyan">
                  <div className="flex items-center gap-4">
                    <div className="w-10 h-10 bg-primary-cyan/10 rounded-xl flex items-center justify-center flex-shrink-0">
                      <HelpCircle className="w-5 h-5 text-primary-blue dark:text-primary-cyan" />
                    </div>
                    <span className="pr-4">{faq.question}</span>
                  </div>
                </AccordionTrigger>
                <AccordionContent className="text-gray-600 dark:text-gray-300 pb-5 pl-14 leading-relaxed">
                  {faq.answer}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>

        {/* CTA */}
        <div className="mt-12 text-center">
          <p className="text-gray-600 dark:text-gray-300 mb-4">
            Vous avez d'autres questions ?
          </p>
          <a
            href="#contact"
            className="inline-flex items-center gap-2 text-primary-blue dark:text-primary-cyan font-semibold hover:underline"
          >
            Passez nous voir en boutique ou contactez-nous
          </a>
        </div>
      </div>
    </section>
  );
};

export default FAQSection;
